import React, { Component } from 'react';
import {
  CssBaseline,
  Grid,
  // makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow as MaterialTableRow,
  // Typography,
  withStyles,
} from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';

import axiosInstance, { WEB_API, getEventId } from '../../constatns';
import AdminTopbar from '../AdminTopbar';
import AdminFooter from '../AdminFooter';
import { CountryList } from '../../common/CountryList';
import SubTitle from '../../components/Text/SubTitle';
import Table from '../../components/Table/Table';

const styles = (theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
    '& > div:not(:first-child)': {
      marginBottom: '30px',
    },
  },
  subTitle: {
    fontSize: '1.2em',
    fontWeight: 600,
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

const TableRow = withStyles((theme) => ({
  root: {
    '& > th:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
    '& > td:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
  },
}))(MaterialTableRow);

class PaperStatusTemp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: {
        oral: 0,
        eposter: 0,
        basic: 0,
        craniofacial: 0,
        handnupper: 0,
        headnneck: 0,
        breast: 0,
        lowerlimb: 0,
        lymphedema: 0,
        eyelid: 0,
        rhinoplasty: 0,
        antiaging: 0,
        facial: 0,
        aesthetic: 0,
        bodycontouring: 0,
        botox: 0,
        laser: 0,
        fatnstem: 0,
        hair: 0,
        Pediatric: 0,
        other: 0,
      },
      countCountry: [],
    };

    this.getCountryData = this.getCountryData.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    axiosInstance.get(`${WEB_API}/paper/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      /*
        // 등록자(isPay 값이 R)만 확인
        for (let item of response.data.Items) {
          if (item.isPay === 'R') {
            console.log(item);
          }
        }
      */
      // console.log(response.data);
      const arrData = response.data.sort((a, b) => {
        return Number(b.createdAt) - Number(a.createdAt);
      });

      this.getData(arrData);
      // console.log(countCountry);
    });
  }

  getData(d) {
    let countTemp = this.getTypeData(d);
    let countryTemp = this.getCountryData(d);

    this.setState((prev) => ({
      count: countTemp,
      countCountry: countryTemp,
    }));

    // console.log(this.state.countCountry);
  }

  getTypeData(d) {
    let buff = cloneDeep(this.state.count);
    //eslint-disable-next-line
    d.map((item) => {
      if (item.presentationType === 'Oral') buff['oral'] += 1;
      if (item.presentationType === 'E-Poster') buff['eposter'] += 1;
      if (item.abstractTopic === 'Basic Research') buff['basic'] += 1;
      if (item.abstractTopic === 'Craniofacial / Trauma') buff['craniofacial'] += 1;
      if (item.abstractTopic === 'Hand & Upper Limb Reconstruction') buff['handnupper'] += 1;
      if (item.abstractTopic === 'Head and Neck Reconstruction') buff['headnneck'] += 1;
      if (item.abstractTopic === 'Breast / Body Reconstruction') buff['breast'] += 1;
      if (item.abstractTopic === 'Lower Limb Reconstruction') buff['lowerlimb'] += 1;
      if (item.abstractTopic === 'Lymphedema') buff['lymphedema'] += 1;
      if (item.abstractTopic === 'Eyelid and Periocular Surgery') buff['eyelid'] += 1;
      if (item.abstractTopic === 'Rhinoplasty') buff['rhinoplasty'] += 1;
      if (item.abstractTopic === 'Anti-aging Surgery') buff['antiaging'] += 1;
      if (item.abstractTopic === 'Facial Contouring Surgery') buff['facial'] += 1;
      if (item.abstractTopic === 'Aesthetic Breast Surgery') buff['aesthetic'] += 1;
      if (item.abstractTopic === 'Body Contouring Surgery') buff['bodycontouring'] += 1;
      if (item.abstractTopic === 'Botox, Filler, Minimally Invasive Surgery') buff['botox'] += 1;
      if (item.abstractTopic === 'Laser') buff['laser'] += 1;
      if (item.abstractTopic === 'Fat and Stem Cell Therapy') buff['fatnstem'] += 1;
      if (item.abstractTopic === 'Hair') buff['hair'] += 1;
      if (item.abstractTopic === 'Other Plastic Surgery') buff['other'] += 1;
      if (item.abstractTopic === 'Pediatric / Craniofacial') buff['Pediatric'] += 1;
    });

    return buff;
  }

  getCountryData(d) {
    // 국가별 통계
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      // if (CountryList[i].name !== 'Korea, Republic of') {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
      // }
    }

    if (d) {
      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < buff.length; j++) {
          // if (buff[j].name === d[i].userInfo.country) {
          //   buff[j].count += 1;
          // }
        }
      }
    }
    return buff;
  }

  renderPrensentationChart() {
    const { count } = this.state;
    return (
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component={'th'} style={{ width: '300px' }}>
              Oral
            </TableCell>
            <TableCell style={{ width: '100px' }}>{count['oral']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>E-Poster</TableCell>
            <TableCell>{count['eposter']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderAbstractTopicChart() {
    const { count } = this.state;
    return (
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component={'th'} style={{ width: '300px' }}>
              Basic Research
            </TableCell>
            <TableCell style={{ width: '100px' }}>{count['basic']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Craniofacial / Trauma</TableCell>
            <TableCell>{count['craniofacial']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Hand & Upper Limb Reconstruction</TableCell>
            <TableCell>{count['handnupper']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Head and Neck Reconstruction</TableCell>
            <TableCell>{count['headnneck']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Breast / Body Reconstruction</TableCell>
            <TableCell>{count['breast']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Lower Limb Reconstruction</TableCell>
            <TableCell>{count['lowerlimb']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Lymphedema</TableCell>
            <TableCell>{count['lymphedema']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Eyelid and Periocular Surgery</TableCell>
            <TableCell>{count['eyelid']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Rhinoplasty</TableCell>
            <TableCell>{count['rhinoplasty']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Anti-aging Surgery</TableCell>
            <TableCell>{count['antiaging']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Facial Contouring Surgery</TableCell>
            <TableCell>{count['facial']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Aesthetic Breast Surgery</TableCell>
            <TableCell>{count['aesthetic']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Body Contouring Surgery</TableCell>
            <TableCell>{count['bodycontouring']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Botox, Filler, Minimally Invasive Surgery</TableCell>
            <TableCell>{count['botox']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Laser</TableCell>
            <TableCell>{count['laser']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Fat and Stem Cell Therapy</TableCell>
            <TableCell>{count['fatnstem']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Hair</TableCell>
            <TableCell>{count['hair']}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell component={'th'}>Pediatric / Craniofacial</TableCell>
            <TableCell>{count['Pediatric']}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'}>Other Plastic Surgery</TableCell>
            <TableCell>{count['other']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderCountryChart() {
    const { countCountry } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>국가명</TableCell>
            <TableCell>인원</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {countCountry.map((item) => (
            // item.count > 0 &&

            <TableRow key={item.name}>
              <TableCell>{item.name}</TableCell>
              <TableCell align="center">{item.count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes } = this.props;
    const { count, countCountry } = this.state;
    return (
      <Grid item xs={12}>
        <CssBaseline />
        <AdminTopbar MIdx={6} SIdx={0} />
        <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
          <Grid item>
            <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
              <Grid item>
                <h1>Status - Free Paper</h1>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>Presentation Type</SubTitle>
            {count && this.renderPrensentationChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>Abstract Topic</SubTitle>
            {count && this.renderAbstractTopicChart()}
          </Grid>
          {/* <Grid item>
            <SubTitle isDecoHidden={true}>국가별 통계</SubTitle>
            {countCountry && this.renderCountryChart()}
          </Grid> */}
        </Grid>
        <AdminFooter />
      </Grid>
    );
  }
}

export default withStyles(styles)(PaperStatusTemp);
